<template>
  <v-container fluid>
    <el-overlay-loading :loading="pageloading" />
    <v-row no-gutters class="mb-5">
      <v-col cols="12" md="10">
        <h2>Administravimas</h2>
      </v-col>
      <v-col cols="12" md="2" class="text-right"> </v-col>
    </v-row>

    <v-sheet class="d-flex justify-start" color="transparent">
      <v-card flat style="width: 200px;" color="transparent" class="mr-5">
        <v-card>
          <v-list dense>
            <v-list-item-group v-model="selectedTab" color="primary" mandatory>
              <v-list-item
                v-for="(item, i) in filteredTabItems"
                :key="i"
                @click="gotoTab(item)"
              >
                <v-list-item-content>
                  <v-list-item-title
                    :class="tabClass(item)"
                    v-text="item.title"
                  ></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </v-card>
      <v-card v-if="activeTab >= 0" width="100%" min-width="800px">
        <component
          :is="tabItems[activeRoute].component"
          :readonly-form="tabItems[activeRoute].readonly"
          class="tabComponent"
        ></component>
      </v-card>
    </v-sheet>
  </v-container>
</template>

<script>
import { authRoute } from './../../router/routeRole'
import unsavedDataRoute from '../../mixins/unsavedDataRoute'

import AdminParametrai from './AdminParametrai'
import AdminKlasifikatoriai from './AdminKlasifikatoriai'
import AdminTeises from './AdminTeises'
import AdminTooltip from './AdminTooltip'
import AdminRegistrai from './AdminRegistrai'
import AdminTaisykles from './AdminTaisykles'
import Ataskaita from '../ataskaita/Ataskaita'
import AdminRegistravimasAutomatu from './AdminRegistravimasAutomatu'
import AdminSiuntimoAdministravimas from './AdminSiuntimoAdministravimas'
import AdminBroker from './AdminBroker'
import AdminBrokerList from './AdminBrokerList'
import AdminSistemaInfo from './AdminSistemaInfo'
import AdminZinute from './AdminZinute'
import AdminGeneravimas from './AdminGeneravimas'
import AdminPasTvarkymas from './AdminPasTvarkymas'

export default {
  name: 'AdminTab',
  mixins: [unsavedDataRoute],
  data() {
    return {
      selectedTab: null,
      pageloading: false,
      tabInfo: {
        obj_dokumento_numeris: null,
      },
    }
  },
  computed: {
    routeItems() {
      return {
        adminAtaskaita: {
          title: 'Ataskaitos',
          route: 'adminAtaskaita',
          component: Ataskaita,
          readonly: false,
        },
        adminParametrai: {
          title: 'Sistemos parametrai',
          route: 'adminParametrai',
          component: AdminParametrai,
          readonly: false,
        },
        adminKlasifikatoriai: {
          title: 'Klasifikatoriai',
          route: 'adminKlasifikatoriai',
          component: AdminKlasifikatoriai,
          readonly: false,
        },
        adminTeises: {
          title: 'NTR teisių tipai ir potipiai',
          route: 'adminTeises',
          component: AdminTeises,
          readonly: false,
        },
        adminRegistrai: {
          title: 'Rankinis duomenų įvedimas',
          route: 'adminRegistrai',
          component: AdminRegistrai,
          readonly: false,
        },
        adminRegistravimasAutomatu: {
          title: 'Registravimas automatu',
          route: 'adminRegistravimasAutomatu',
          component: AdminRegistravimasAutomatu,
          readonly: false,
        },
        adminTaisykles: {
          title: 'Susipažinimas su taisyklėmis',
          route: 'adminTaisykles',
          component: AdminTaisykles,
          readonly: false,
        },
        adminTooltip: {
          title: 'Tooltips',
          route: 'adminTooltip',
          component: AdminTooltip,
          readonly: false,
        },
        adminSiuntimoAdministravimas: {
          title: 'Siuntimo administravimas',
          route: 'adminSiuntimoAdministravimas',
          component: AdminSiuntimoAdministravimas,
          readonly: false,
        },
        adminBroker: {
          title: 'RC Broker',
          route: 'adminBroker',
          component: AdminBroker,
          readonly: false,
        },
        adminBrokerList: {
          title: 'RC Broker užklausos',
          route: 'adminBrokerList',
          component: AdminBrokerList,
          readonly: false,
        },
        adminSistemaInfo: {
          title: 'Sistemos informavimas',
          route: 'adminSistemaInfo',
          component: AdminSistemaInfo,
          readonly: false,
        },
        adminZinute: {
          title: 'Sistemos atnaujinimai',
          route: 'adminZinute',
          component: AdminZinute,
          readonly: false,
        },
        adminGeneravimas: {
          title: 'PDF generavimas',
          route: 'adminGeneravimas',
          component: AdminGeneravimas,
          readonly: false,
        },
        adminPasTvarkymas: {
          title: 'Įvykdytas per PAS',
          route: 'adminPasTvarkymas',
          component: AdminPasTvarkymas,
          readonly: false,
        },
      }
    },
    tabItems() {
      return Object.entries(this.routeItems).map(([key, item]) => {
        return item
      })
    },
    filteredTabItems() {
      return this.tabItems.filter(item => {
        return !item.hide && authRoute(item.route)
      })
    },
    activeTab: {
      set(value) {
        this.selectedTab = value
      },
      get() {
        return this.filteredTabItems.findIndex(function(item, index) {
          return this.$route.matched.find(element => {
            if (item.route === element.name) {
              return true
            }
          })
        }, this)
      },
    },
    activeRoute() {
      return this.tabItems.findIndex(function(item, index) {
        if (this.isActiveRoute(item.route)) {
          return true
        }
      }, this)
    },
  },
  created() {
    this.selectedTab = this.activeTab
  },
  methods: {
    gotoTab(item) {
      if (this.$route.name !== item.route) {
        this.$router.push({
          name: item.route,
        })
      }
    },
    tabClass(item) {
      return 'tabItem ' + (item.readonly ? 'readonly' : '')
    },
    isActiveRoute(routeName) {
      return (
        this.$route.matched.filter(item => item.name === routeName).length > 0
      )
    },
  },
}
</script>
<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
.tabItem {
  &.readonly {
    color: $secondary;
  }
}
.tabComponent {
  margin: 0 auto 0 0;
}
</style>
